import styled, { css } from 'styled-components';

import LinkWithLocale from '@/components/LinkWithLocale/LinkWithLocale';

export const SubmenuBox = styled.div`
  opacity: 0.3;
  animation: submenu 1s forwards;
  @keyframes submenu {
    0% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const DesktopMegamenu = styled.div`
  display: flex;
  padding: 32px 40px 40px 40px;
  position: relative;
  ${({ theme }) => css`
    display: none;
    ${theme.media.md.up} {
      display: flex;
    }
  `}
`;

export const UL = styled.ul`
  display: block !important;
  .itemGroupTitle {
    margin-bottom: 18px;
  }
  .subMenuItem {
    margin: 13px 0px;
  }
`;

export const List = styled.li`
  cursor: default;
  display: block;
  width: 100%;
  ul {
    display: block;
  }
`;

export const Item = styled(LinkWithLocale)`
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;
  transition: color 0.2s;
  white-space: nowrap;
  font-style: normal;
  line-height: 20px;
  padding-bottom: 3px;
  border-bottom: 2px solid ${({ theme }) => theme.colors.primaryBlue};
  -webkit-mask: conic-gradient(at bottom 0px left 0px, #0000 -180deg, #000 0) 0
      var(--_i, 200%) / var(--_i, 0px) 200% border-box no-repeat,
    linear-gradient(#000 0 0) padding-box no-repeat;
  transition: 0.3s, -webkit-mask-position 0.3s 0.3s;
  ${({
    theme: {
      colors: { almostBlack, primaryBlue },
      fontFamilies,
    },
  }) => css`
    &:hover {
      --_i: 100%;
      transition: 0s, -webkit-mask-size 0.3s 0.3s;
      color: ${primaryBlue} !important;
      border-bottom: 2px solid ${primaryBlue};
    }
    color: ${almostBlack};
    font-family: ${fontFamilies.openSans};
  `}
`;

export const MenuBox = styled.div<{ menuWidth: number }>`
  width: ${({ menuWidth }) => menuWidth}%;
  & > ul {
    display: flex;
    align-items: flex-start;
    gap: 2rem;
  }
  ${({
    theme: {
      colors: { almostBlack },
    },
  }) => css`
    * {
      color: ${almostBlack} !important;
    }
  `}
`;

export const IMGBox = styled.div<{ $menuWidth: number }>`
  width: ${({ $menuWidth }) => $menuWidth}%;
  max-height: 400px;
  object-fit: cover;
  object-position: center;
  text-align: right;
  margin-left: 40px;
  overflow: hidden;
  opacity: 0.3;
  animation: Imager 1s forwards;

  @keyframes Imager {
    0% {
      opacity: 0.3;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const IMG = styled.img`
  width: 100%;
  transition: transform 1000ms;
  &:hover {
    -ms-transform: scale(1.05);
    -webkit-transform: scale(1.05);
    transform: scale(1.05);
  }
`;

export const MobileMegamenu = styled.div``;
